import {useEffect, useRef, useState} from 'react';
import AdminBanner from './AdminBanner';
import styles from './MomentNativeBanner.module.scss';
import useLoadBannerSdk from '../../../commonSub/hook/useLoadBannerSdk';
import useTypedSelector from '../../hook/useTypedSelector';
import {IAdminBannerComponent} from '../../type';
import SingleText from '../SingleText';
import Text from '../Text';

interface IProps {
  contentId: number;
  unitId: string;
  w: number;
  defaultBanner?: IAdminBannerComponent;
}

export default function MomentNativeBanner({
  contentId,
  unitId,
  w,
  defaultBanner,
}: IProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [isRendered, setIsRendered] = useState(false);
  const [isVideoType, setIsVideoType] = useState(false);
  const isImageType = !isVideoType;
  const [showDefaultBanner, setShowDefaultBanner] = useState(false);
  useLoadBannerSdk('native');
  const isLoaded = useTypedSelector(
    state => state.common.isLoadedBannerSdk.native
  );
  useEffect(() => {
    if (!isLoaded) return;

    const AdfitNativeAds = (window as any).AdfitNativeAds;
    // http://guide.ad.sdk.at.kakaocorp.com/web/native-ad/3_api.html
    AdfitNativeAds &&
      new AdfitNativeAds({unitId})
        .renderFail(() => setShowDefaultBanner(true))
        .beforeComplete(() => setIsRendered(true))
        .init();
  }, [unitId, isLoaded]);

  useEffect(() => {
    const el = ref.current;
    if (el && isRendered) {
      const hasVideoEl = !!el.querySelector('video');
      setIsVideoType(hasVideoEl);
    }
  }, [isRendered]);

  return (
    <>
      {showDefaultBanner && defaultBanner && (
        // TODO: 디폴트 배너 레이아웃이 깨진다.
        <AdminBanner type="adBigMoment" adminAd={defaultBanner} />
      )}
      {!showDefaultBanner && (
        <div
          adfit-unit-id={unitId}
          adfit-param-cp={contentId}
          adfit-param-channel="kakaowebtoon"
          ref={ref}
        >
          <div className="relative rounded-12 overflow-hidden">
            <div
              className={cn(
                'w-full absolute py-8',
                'items-center flex z-1',
                'after:left-0 after:absolute after:w-full after:-z-1',
                'bottom-0 after:bottom-0',
                isVideoType && 'after:h-[60px]',
                isImageType && 'after:h-[92px]',
                styles.infoBox,
                {
                  [styles.isVideoType]: isVideoType,
                  [styles.isImageType]: isImageType,
                }
              )}
            >
              <SingleText
                adfit-title=""
                className={cn(
                  's14-regular-white',
                  'px-12 leading-23 flex-auto tracking-[-0.5px]'
                )}
              >
                {' '}
              </SingleText>
              <Text
                adfit-action-button=""
                adfit-landing-url=""
                className={cn(
                  's12-regular-white',
                  'pt-5 pb-3 px-12 mr-8 rounded-2',
                  'bg-black/10',
                  'relative',
                  'border border-solid border-white/40',
                  'flex-none overflow-hidden tracking-[-0.5px]'
                )}
              >
                {' '}
              </Text>
            </div>
            <img
              adfit-image-width={w}
              adfit-main-img-url=""
              adfit-landing-url=""
              className={cn('block mx-auto max-w-full', styles.image)}
              alt=""
            />
            <a
              adfit-ad-info=""
              className={cn('absolute top-0 pt-4', {
                'left-0 right-auto pl-4': isVideoType,
                'right-0 pr-4': isImageType,
              })}
            />
          </div>
        </div>
      )}
    </>
  );
}
